export default "__VITE_ASSET__Dxa3a0CN__"